var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.89543 0 2 0H9.53162C9.62393 0 9.71549 0.00637534 9.80573 0.0188579C9.86857 0.00648538 9.93353 0 10 0C10.3788 0 10.7084 0.210614 10.8781 0.521127C10.9455 0.582465 11.009 0.648722 11.0681 0.719631L15.5364 6.08168C15.582 6.13635 15.6244 6.19318 15.6636 6.25191C15.87 6.43509 16 6.70236 16 7C16 7.05111 15.9962 7.10132 15.9888 7.15037C15.9962 7.2204 16 7.29106 16 7.36205V18C16 19.1046 15.1046 20 14 20H2C0.89543 20 0 19.1046 0 18V2ZM2 2H9V6C9 7.10457 9.89543 8 11 8H14V18H2V2ZM11 3.76205L12.865 6H11V3.76205ZM5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H6C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6H5ZM5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H5ZM5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H11C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14H5Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.b57e2896.svg";
export { ForwardRef as ReactComponent };